import { render, staticRenderFns } from "./MovingToAddressFormPart.vue?vue&type=template&id=23c8f8a1"
import script from "./MovingToAddressFormPart.vue?vue&type=script&lang=js"
export * from "./MovingToAddressFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports